module.exports = __webpack_public_path__ + "img/go_share.4125d1e7.png";